import { Component, OnInit } from '@angular/core'


@Component({
    selector: 'app-setting',
    templateUrl: './setting.component.html',
})
export class SettingComponent implements OnInit {

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/setting.component.ts